import { type Action } from '@reduxjs/toolkit';
import { call, type CallEffect, put, type PutEffect } from 'redux-saga/effects';
import { type Socket } from 'socket.io-client';

import { isRequestFailed } from '../request-failed/reducer';
import { sendRaw } from '../send-request';
import { emailValidatorVerify, emailValidatorVerifyTimeout } from './reducer';

export const EMAIL_VERIFY_TIMEOUT_MS = 30000;

function* sendWithTimeout(
  socket: Socket,
  action: ReturnType<typeof emailValidatorVerify>,
): Generator<CallEffect | PutEffect, void, Action> {
  const response: Action = yield call(sendRaw, socket, action, {
    timeoutMs: EMAIL_VERIFY_TIMEOUT_MS,
  });

  if (isRequestFailed(response)) {
    yield put(
      emailValidatorVerifyTimeout({
        correlationId: action.payload.correlationId,
        email: action.payload.email,
      }),
    );
    return;
  }

  yield put(response);
}

export { sendWithTimeout };
